import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Image, SimpleGrid, Text, useMultiStyleConfig} from '@chakra-ui/react'

const TopicsSection = ({title, subtitle, topics}) => {
    const styles = useMultiStyleConfig('TopicsSection')
    if (!title && !subtitle && !topics?.length) return null
    return (
        <Box as="section" data-testid="topics-section" {...styles.container}>
            <Flex {...styles.header}>
                {title && <Text {...styles.title}>{title}</Text>}
                {subtitle && <Text {...styles.subtitle}>{subtitle}</Text>}
            </Flex>

            <SimpleGrid {...styles.grid}>
                {topics?.map((topic, index) => (
                    <Flex key={topic?._metadata?.uid || topic?.title || index} {...styles.card}>
                        {topic?.icon?.url && (
                            <Image src={topic.icon.url} alt={topic.title || ''} {...styles.icon} />
                        )}
                        <Flex {...styles.cardContent}>
                            {topic?.title && <Text {...styles.cardTitle}>{topic.title}</Text>}
                            {topic?.subtitle && (
                                <Text {...styles.description}>{topic.subtitle}</Text>
                            )}
                        </Flex>
                    </Flex>
                ))}
            </SimpleGrid>
        </Box>
    )
}

TopicsSection.displayName = 'TopicsSection'

TopicsSection.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string}),
            title: PropTypes.string,
            subtitle: PropTypes.string,
            _metadata: PropTypes.shape({uid: PropTypes.string}),
        }),
    ),
}

export default TopicsSection
